// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"News-module--wrapper--iGNM2","posts":"News-module--posts--xWJ7X","post":"News-module--post--fNUH_","noPosts":"News-module--noPosts--275I3"};